import { RudderTyperAnalytics } from '../types/index';
import { getStageMode } from '../helpers/getStageMode';
import { createStageInjectedProxy } from './createStageInjectedProxy';
const stage = getStageMode();
export const ProxiedAnalytics = createStageInjectedProxy(RudderTyperAnalytics, stage);
